// extracted by mini-css-extract-plugin
module.exports = {"submitImage":"_37YvN","trackingPixel":"_31jOp"};